// Module imports
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
// Injection Tokens
import { ADDITIONAL_AUTOCOMPLETER_QUERY_PARAMS } from 'NewAngular/superclasses/autocompleter-additional-query-params';
import * as i0 from "@angular/core";
export class StocksEditProfileModalModule {
}
StocksEditProfileModalModule.ɵfac = function StocksEditProfileModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StocksEditProfileModalModule)(); };
StocksEditProfileModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StocksEditProfileModalModule });
StocksEditProfileModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        {
            provide: ADDITIONAL_AUTOCOMPLETER_QUERY_PARAMS,
            useValue: {
                le_o: 'quote_page_autocompleter',
            },
        },
    ], imports: [AddButtonAutocompleteModule,
        CommonModule,
        ModalBaseModule,
        FeatureNeededModule,
        IconModule,
        TooltipModule] });
